module.exports = __webpack_public_path__ + "img/global__plus.d6fc3ad1.svg";